import { IconFavoriteFill, IconNearMe, IconRefresh, IconStore } from '@fhs/ui';
import { EmptyStateCategories } from '@fhs-legacy/frontend/src/components/store-locator-empty-states/types';
import { OrderLocatorTab } from '@fhs-legacy/frontend/src/utils/launchdarkly/variations';

type EmptyStateIcon = typeof IconStore;

const TAB_ICONS: Partial<Record<OrderLocatorTab, EmptyStateIcon>> = {
  [OrderLocatorTab.NEARBY]: IconStore,
  [OrderLocatorTab.FAVORITE]: IconFavoriteFill,
  [OrderLocatorTab.RECENT]: IconRefresh,
};

/**
 * Each tab keeps a single glyph across its categories. The nearby tab's no-location state is the
 * one exception: the design swaps the storefront for the near-me arrow.
 */
export function getEmptyStateIcon(
  tab: OrderLocatorTab,
  category: EmptyStateCategories
): EmptyStateIcon {
  if (category === EmptyStateCategories.NO_LOCATION) {
    return IconNearMe;
  }

  return TAB_ICONS[tab] ?? IconStore;
}
